// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.extraInfo{
    padding: 2%;
    
    /* display: flex; */
}
.extraInfo .extraBTN{
    
    background-color: transparent;
    border: none;
    justify-content: baseline;
    color:#FDDC79 ;
    font-weight: bold;
}
.extraInfo p{
    display: flex;
    align-items: center;
}
.containerCard{
    padding-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-weight: bold;
    /* position: absolute; */
    height: 100%;
    flex-direction: column;
}
#titlelogin{
    font-size: 50px;
}

.cardlogin{
    background-color: #A0CED9;
    width: 70%;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 70%;
    border-radius:50px 50px 0px 0px;
}
.cardFormLogin{
    position: absolute;
    z-index: -1;
}
.cardHeaderLogin{
    border-radius:50px 50px 0px 0px !important;
    color:transparent;
    background-color: #A0CED9;
    padding-left: 50px;
    padding-top: 20px;
    border: none;
    font-size: 30px;
    font-weight: bold;
}
.cardBody{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.loginstyle{
    background-color: #A0CED9;
}
.rootDiv{
    background-color: transparent;
    /* background-color:#A0CED9 ; */
    /* position: absolute; */
    height: 100%;
    /* height: 100%  !important; */
}
.form-control:focus{
    border-color: #FDDC79;
    box-shadow: 0px 0px 0px .10rem #FDDC79;
}
.form-floating{
    border:none;
    /* border: solid 1px grey; */
    border-radius: 15px;
    width: 90%;
    /* height: 40px !important; */
}
.input-group {
    border:none;
    /* border: solid 1px grey; */
    border-radius: 15px;
    /* width: 90%; */
}
.input-group .buttonToogle{
    border-radius: 15px;
}

.form-control{
    border-radius: 15px;
    /* height: 20px !important; */
}


.loginButton{
    width: 50%;
    background-color: transparent;
    border-color: black;
    color: black;
    border-radius: 30px;

}

@media only screen and (max-width: 767px) {
    .cardlogin{
        width: 70%;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 70%;
        border-radius:50px 50px 0px 0px;
    }
    .mobileForm{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .desktopform{
        display: none;
        justify-content: center;
        width: 90%;
        flex-direction: column;
        align-items: center;
        height: 500px;
    }

}

@media only screen and (min-width: 768px) and (max-width: 1050px){
    .cardlogin{
        width: 70%;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 70%;
        border-radius:50px 50px 0px 0px;
    }
    .cardHeaderLogin{
        display: flex;
        justify-content: left;
        text-align: left;
    }
    .mobileForm{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .desktopform{
        display: none;
        justify-content: center;
        width: 90%;
        flex-direction: column;
        align-items: center;
        height: 500px;
    }
}
@media only screen and (min-width: 1050px) {
    .cardHeaderLogin{
        border-radius: 50px 0px 50px 0px;
        position: fixed;

    }
    .containerCard{
        display: flex;
        width: 50%;
        justify-content: center;
        
    }
    .mobileForm{
        display: none;
    }
    .desktopform{
        display: flex;
        justify-content: center;
        width: 90%;
        flex-direction: column;
        align-items: center;
        height: 500px;
    }
    .cardlogin{
        right: 0;
        left:auto;
        top:0;
        height: 100%;
        width: 50%;
        border-radius:50px 0px 0px 50px;
    }
  }


`, "",{"version":3,"sources":["webpack://./src/components/LoginCard/LoginCard.css"],"names":[],"mappings":";AACA;IACI,WAAW;;IAEX,mBAAmB;AACvB;AACA;;IAEI,6BAA6B;IAC7B,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,sBAAsB;AAC1B;AACA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,eAAe;IACf,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,+BAA+B;AACnC;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,0CAA0C;IAC1C,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,wBAAwB;IACxB,YAAY;IACZ,8BAA8B;AAClC;AACA;IACI,qBAAqB;IACrB,sCAAsC;AAC1C;AACA;IACI,WAAW;IACX,4BAA4B;IAC5B,mBAAmB;IACnB,UAAU;IACV,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,4BAA4B;IAC5B,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;AACjC;;;AAGA;IACI,UAAU;IACV,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;;AAEvB;;AAEA;IACI;QACI,UAAU;QACV,eAAe;QACf,SAAS;QACT,OAAO;QACP,WAAW;QACX,WAAW;QACX,+BAA+B;IACnC;IACA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,uBAAuB;QACvB,UAAU;QACV,sBAAsB;QACtB,mBAAmB;QACnB,aAAa;IACjB;;AAEJ;;AAEA;IACI;QACI,UAAU;QACV,eAAe;QACf,SAAS;QACT,OAAO;QACP,WAAW;QACX,WAAW;QACX,+BAA+B;IACnC;IACA;QACI,aAAa;QACb,qBAAqB;QACrB,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,uBAAuB;QACvB,UAAU;QACV,sBAAsB;QACtB,mBAAmB;QACnB,aAAa;IACjB;AACJ;AACA;IACI;QACI,gCAAgC;QAChC,eAAe;;IAEnB;IACA;QACI,aAAa;QACb,UAAU;QACV,uBAAuB;;IAE3B;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,uBAAuB;QACvB,UAAU;QACV,sBAAsB;QACtB,mBAAmB;QACnB,aAAa;IACjB;IACA;QACI,QAAQ;QACR,SAAS;QACT,KAAK;QACL,YAAY;QACZ,UAAU;QACV,+BAA+B;IACnC;EACF","sourcesContent":["\n.extraInfo{\n    padding: 2%;\n    \n    /* display: flex; */\n}\n.extraInfo .extraBTN{\n    \n    background-color: transparent;\n    border: none;\n    justify-content: baseline;\n    color:#FDDC79 ;\n    font-weight: bold;\n}\n.extraInfo p{\n    display: flex;\n    align-items: center;\n}\n.containerCard{\n    padding-top: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    font-weight: bold;\n    /* position: absolute; */\n    height: 100%;\n    flex-direction: column;\n}\n#titlelogin{\n    font-size: 50px;\n}\n\n.cardlogin{\n    background-color: #A0CED9;\n    width: 70%;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 70%;\n    border-radius:50px 50px 0px 0px;\n}\n.cardFormLogin{\n    position: absolute;\n    z-index: -1;\n}\n.cardHeaderLogin{\n    border-radius:50px 50px 0px 0px !important;\n    color:transparent;\n    background-color: #A0CED9;\n    padding-left: 50px;\n    padding-top: 20px;\n    border: none;\n    font-size: 30px;\n    font-weight: bold;\n}\n.cardBody{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.loginstyle{\n    background-color: #A0CED9;\n}\n.rootDiv{\n    background-color: transparent;\n    /* background-color:#A0CED9 ; */\n    /* position: absolute; */\n    height: 100%;\n    /* height: 100%  !important; */\n}\n.form-control:focus{\n    border-color: #FDDC79;\n    box-shadow: 0px 0px 0px .10rem #FDDC79;\n}\n.form-floating{\n    border:none;\n    /* border: solid 1px grey; */\n    border-radius: 15px;\n    width: 90%;\n    /* height: 40px !important; */\n}\n.input-group {\n    border:none;\n    /* border: solid 1px grey; */\n    border-radius: 15px;\n    /* width: 90%; */\n}\n.input-group .buttonToogle{\n    border-radius: 15px;\n}\n\n.form-control{\n    border-radius: 15px;\n    /* height: 20px !important; */\n}\n\n\n.loginButton{\n    width: 50%;\n    background-color: transparent;\n    border-color: black;\n    color: black;\n    border-radius: 30px;\n\n}\n\n@media only screen and (max-width: 767px) {\n    .cardlogin{\n        width: 70%;\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        height: 70%;\n        border-radius:50px 50px 0px 0px;\n    }\n    .mobileForm{\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n    }\n    .desktopform{\n        display: none;\n        justify-content: center;\n        width: 90%;\n        flex-direction: column;\n        align-items: center;\n        height: 500px;\n    }\n\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1050px){\n    .cardlogin{\n        width: 70%;\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        height: 70%;\n        border-radius:50px 50px 0px 0px;\n    }\n    .cardHeaderLogin{\n        display: flex;\n        justify-content: left;\n        text-align: left;\n    }\n    .mobileForm{\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n    }\n    .desktopform{\n        display: none;\n        justify-content: center;\n        width: 90%;\n        flex-direction: column;\n        align-items: center;\n        height: 500px;\n    }\n}\n@media only screen and (min-width: 1050px) {\n    .cardHeaderLogin{\n        border-radius: 50px 0px 50px 0px;\n        position: fixed;\n\n    }\n    .containerCard{\n        display: flex;\n        width: 50%;\n        justify-content: center;\n        \n    }\n    .mobileForm{\n        display: none;\n    }\n    .desktopform{\n        display: flex;\n        justify-content: center;\n        width: 90%;\n        flex-direction: column;\n        align-items: center;\n        height: 500px;\n    }\n    .cardlogin{\n        right: 0;\n        left:auto;\n        top:0;\n        height: 100%;\n        width: 50%;\n        border-radius:50px 0px 0px 50px;\n    }\n  }\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
